import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useDownloadDictionaries = ({ code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.DOWNLOAD_DICTIONARIES, code }), [code]);
};

export default {
  useDownloadDictionaries,
};
